import QuizFields from './QuizFields.svelte';
import QuizSettings from './QuizSettings.svelte';
import QuizStyling from './QuizStyling.svelte';
import QuizResults from './QuizResults.svelte';

export let QuizWidgetApi = {
    Fields: (target, widget, onChange, onRenderStep) => {
        return new QuizFields({
            target: target,
            props: {
                widget: widget,
                onChange: onChange,
                onRenderStep: onRenderStep
            }
        });
    },
    Settings: (target, widget, onChange, onStructureChange) => {
        return new QuizSettings({
            target: target,
            props: {
                widget: widget,
                onChange: onChange,
                onStructureChange: onStructureChange
            }
        });
    },
    Results: (target, widget, onChange) => {
        return new QuizResults({
            target: target,
            props: {
                widget: widget,
                onChange: onChange
            }
        });
    },
    Styling: (target, widget, onChange, onRenderStep) => {
        return new QuizStyling({
            target: target,
            props: {
                widget: widget,
                onChange: onChange,
                onRenderStep: onRenderStep
            }
        });
    }
};